import React from "react";
import Sidebar from "../admin/sidebar/Sidebar";
import AdminGalleryHome from "../admin/blog/Gallery";
function AdminGalleryPages() {

  return (
    <div>
      <Sidebar />
      <AdminGalleryHome/>
    </div>
  ); 
}
   
export default AdminGalleryPages;
